import { gql } from 'apollo-angular';
import { environment } from '@env/environment';
import { extractQueryFields } from '@common/core/utils/graphql.utils';

const queryFields = extractQueryFields(environment.apiProperties);

export const PICKUP_IN_STORE_LIST_FIELDS = gql`
  fragment PickupInStoreListFields on object_CollectOrdersInStore {
    id
    orderNumber
    status
    pickedAt
    creationDate
    order {
      ... on object_SalesOrder {
        id
        customerFirstname
        customerLastname
        customerFirstname
        customerLastname
        paymentStatus
        fulfillmentStatus
        orderNumber
        paymentInfo {
          ... on fieldcollection_PaymentInfo {
            paymentStatus
          }
        }
      }
    }
  }
`;

export const PICKUP_IN_STORE_NESTED_ORDER = gql`
  fragment PickupInStoreOrderFields on object_SalesOrder {
    id
    orderNumber
    orderDate
    customerFirstname
    customerLastname
    paymentStatus
    fulfillmentStatus
    #    orderHistory { FIXME
    #      event
    #      eventDate
    #    }
    paymentInfo {
      ... on fieldcollection_PaymentInfo {
        shopAmount
        shopCurrency
        customerAmount
        customerCurrency
        paymentStatus
        gateway
        paymentKind
      }
    }
    currency
    deliveryCompany
    deliveryStreet
    deliveryCity
    deliveryZip
    deliveryProvince
    deliveryCountry
    customerFirstname
    customerLastname
    customerFullName
    customerEmail
    customerStreet
    customerCity
    customerZip
    customerCompany
    customerProvince
    customerProvinceCode
    customerCountry
    customerPhone
    totalPrice
    salesOrderItems {
      ... on object_SalesOrderItem {
        id
        quantity
        productName
        totalPrice
        product {
          ... on object_Product {
            sku
            images {
              ... on fieldcollection_ImageInfo {
                image {
                  filename
                  fullpath
                }
              }
            }
            ${queryFields}
            parent {
              ... on object_Product {
                sku
                images {
                  ... on fieldcollection_ImageInfo {
                    image {
                      filename
                      fullpath
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const PICKUP_IN_STORE_DETAILS_FIELDS = gql`
  ${PICKUP_IN_STORE_NESTED_ORDER}
  fragment PickupInStoreDetailsFields on object_CollectOrdersInStore {
    id
    orderNumber
    clickAndCollectStore
    status
    receivedInStoreAt
    pickedAt
    movedToBeReturnedAt
    returnedBackToWarehouseAt
    verificationCustomerCode
    creationDate
    receivedInStoreAt
    customerFullName
    order {
      ...PickupInStoreOrderFields
    }
  }
`;
